/* eslint-disable
    @typescript-eslint/no-explicit-any,
    react/prefer-stateless-function
*/
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';

import * as benchlingUtil from 'BenchlingUtil';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import * as DateUtil from 'util/DateUtil';

interface Props {
  creator: any;
  owner: any;
  modifiedAt: string;
  stepByStepURL: string;
}

export default class ExtraInfo extends React.Component<Props> {
  render(): JSX.Element {
    return (
      <div className="protocol-extra-info protocol-condensed-col">
        <div className="protocol-updated all-caps">
          {`Updated ${DateUtil.readableTime(new Date(this.props.modifiedAt))}`}
        </div>
        <div>
          {
            // onTouchStart handler to allow :active state to work on mobile safari.
            <a
              className="step-by-step-btn all-caps"
              href={this.props.stepByStepURL}
              onTouchStart={function () {
                return null;
              }}
              onClick={function (e: any): void {
                benchlingUtil.navigate(e);
              }}
            >
              <span className="extra-text">Step-by-step</span>
              <BenchlingIcon icon="circle-play-outline" />
            </a>
          }
          <div className="user-img">
            <img src={this.props.owner.avatar_url} width={20} height={20} />
          </div>
          <span className="owner-name">
            {this.props.owner.url_identifier === this.props.creator.url_identifier
              ? `by ${this.props.owner.name}`
              : `by ${this.props.owner.name} (created by ${this.props.creator.name})`}
          </span>
        </div>
      </div>
    );
  }
}
